module.exports = __webpack_public_path__ + "b2f2586606dd72735eca697dcfc190b8.svg";